export default __webpack_public_path__ + "static/media/TL06.b81a84de.mp3";